import React, { createContext, useEffect, useState } from "react";

import { PropsType } from "../../interfaces/ChildrenType";

import { CustomerClassification } from "../../interfaces/CustomerClassification";

import { CustomerClassificationContextType } from "./customer-classification-context.types";

const customerClassificationData = sessionStorage.getItem("CEX-CustomerClassification");

const initialState: CustomerClassificationContextType = {
  customerClassification: JSON.parse(customerClassificationData as string) || null,

  setCustomerClassification: () => {},
};

export const CustomerClassificationContext = createContext(initialState);

export const CustomerClassificationContextProvider: React.FC<PropsType> = ({ children }) => {
  const [customerClassification, setCustomerClassification] = useState<CustomerClassification | null>(initialState.customerClassification);

  useEffect(() => {
    if (customerClassification) {
      sessionStorage.setItem('CEX-CustomerClassification', JSON.stringify(customerClassification))
    }
  }, [customerClassification])

  return (
    <CustomerClassificationContext.Provider value={{ customerClassification, setCustomerClassification }}>
      {children}
    </CustomerClassificationContext.Provider>
  );
};
